import React, { useContext, useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { AppContext } from "../../../Contexts/AppContext";
import swiperList from "./SwiperList";

const Hero = () => {
  const context = useContext(AppContext);
  const [currentBG, setCurrentBG] = useState("");
  const [currentText, setCurrentText] = useState("");
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWidth(window.innerWidth);
    };
    window.addEventListener("resize", handleResize);

    setCurrentBG(
      context.isLight
        ? context.currentTheme["business"].bg
        : context.currentTheme["business"].dark_bg
    );
    setCurrentText(
      context.isLight
        ? context.currentTheme["business"].text
        : context.currentTheme["business"].dark_text
    );

    return (_) => {
      window.removeEventListener("resize", handleResize);
    };
  }, [context]);
  return (
    <div
      style={{
        backgroundColor: currentBG,
        color: currentText,
      }}
      className="flex min-h-[calc(100vh-56px)] items-stretch justify-center transition-all duration-500"
    >
      <Swiper
        spaceBetween={30}
        loop
        navigation={width > 1024}
        autoplay={{
          delay: 4000,
          disableOnInteraction: false,
        }}
        modules={[Autoplay, Navigation]}
      >
        {swiperList.map((swiper, index) => (
          <SwiperSlide key={index}>
            <img
              src={swiper.img}
              className="h-[calc(100vh-56px)] w-screen object-cover"
              alt="product"
            />
            <a
              href={swiper.link}
              target="_blank"
              rel="noreferrer"
              className="absolute top-1/2 left-0 right-0 translate-y-[-50%] bg-[#26172c55] py-5 text-center text-xl font-bold text-white backdrop-blur transition-all hover:bg-[#fff5] hover:text-[#26172c] xs:text-2xl ss:text-3xl md:text-5xl"
            >
              {swiper.title}
            </a>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default Hero;
